// Created by: Imran Khan July 2026
import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { FY_MONTHS } from "./financialYearUtils";

Chart.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function DashboardBarChart({ title, monthly = [] }) {
  const chartData = useMemo(() => {
    const map = Object.fromEntries(monthly.map((row) => [row.month, row]));
    return {
      labels: FY_MONTHS,
      datasets: [
        {
          label: "Cash",
          data: FY_MONTHS.map((month) => map[month]?.cash ?? 0),
          backgroundColor: "#4CAF50",
        },
        {
          label: "Cheque",
          data: FY_MONTHS.map((month) => map[month]?.cheque ?? 0),
          backgroundColor: "#2196F3",
        },
        {
          label: "Others",
          data: FY_MONTHS.map((month) => map[month]?.others ?? 0),
          backgroundColor: "#FF9800",
        },
      ],
    };
  }, [monthly]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { position: "bottom" } },
    scales: {
      x: { stacked: false },
      y: { beginAtZero: true },
    },
  };

  return (
    <div className="fy-panel fy-panel-chart">
      {title && <h5 className="fy-panel-title">{title}</h5>}
      <div className="fy-chart-container">
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
}
